import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Heart } from 'lucide-react';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 5 && !hasShown) {
        setIsVisible(true);
        setHasShown(true);
      }
    };
    const timeout = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
    }, 5000);
    return () => {
      clearTimeout(timeout);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasShown]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setIsVisible(false), 2500);
  };
  return <AnimatePresence data-id="element-163">
      {isVisible && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-charcoal/60 backdrop-blur-sm z-[100]" onClick={() => setIsVisible(false)} data-id="element-164" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 0.35,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="fixed inset-0 z-[101] flex items-center justify-center p-4" data-id="element-165">
            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-md" data-id="element-166">
              <div className="bg-olive py-6 px-6 text-center relative" data-id="element-167">
                <button onClick={() => setIsVisible(false)} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors" aria-label="Close popup" data-id="element-168">
                  <X size={16} data-id="element-169" />
                </button>
                <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-3" data-id="element-170">
                  <Heart size={24} className="text-white" data-id="element-171" />
                </div>
                <h3 className="font-heading text-xl font-bold text-white" data-id="element-172">
                  Before You Go...
                </h3>
              </div>

              <div className="p-6" data-id="element-173">
                {!submitted ? <>
                    <p className="text-charcoal/80 text-base text-center mb-6 font-medium leading-relaxed" data-id="element-174">
                      Taking the first step is the hardest part. Leave your
                      details and we'll reach out to help you get started on
                      your healing journey.
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-4" data-id="element-175">
                      <div data-id="element-176">
                        <label htmlFor="popup-email" className="block text-sm font-bold text-charcoal mb-1.5 uppercase tracking-wide" data-id="element-177">
                          Email Address
                        </label>
                        <input type="email" id="popup-email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" className="w-full px-4 py-3 rounded-lg border border-charcoal/15 bg-charcoal/5 focus:border-olive focus:ring-2 focus:ring-olive/20 outline-none transition-all font-medium text-charcoal text-base" data-id="element-178" />
                      </div>
                      <div data-id="element-179">
                        <label htmlFor="popup-phone" className="block text-sm font-bold text-charcoal mb-1.5 uppercase tracking-wide" data-id="element-180">
                          Phone Number{' '}
                          <span className="text-charcoal/40 font-normal normal-case" data-id="element-181">
                            (optional)
                          </span>
                        </label>
                        <input type="tel" id="popup-phone" value={phone} onChange={e => setPhone(e.target.value)} placeholder="(555) 000-0000" className="w-full px-4 py-3 rounded-lg border border-charcoal/15 bg-charcoal/5 focus:border-olive focus:ring-2 focus:ring-olive/20 outline-none transition-all font-medium text-charcoal text-base" data-id="element-182" />
                      </div>
                      <button type="submit" className="w-full bg-olive hover:bg-olive/90 text-white py-3.5 rounded-lg font-bold text-base transition-all shadow-soft uppercase tracking-wide" data-id="element-183">
                        Get in Touch
                      </button>
                    </form>

                    <p className="text-xs text-charcoal/50 text-center mt-4 font-medium" data-id="element-184">
                      We respect your privacy. No spam, ever.
                    </p>
                  </> : <div className="text-center py-6" data-id="element-185">
                    <div className="w-16 h-16 rounded-full bg-olive/10 flex items-center justify-center mx-auto mb-4" data-id="element-186">
                      <Heart size={28} className="text-olive" data-id="element-187" />
                    </div>
                    <h4 className="font-heading text-lg font-bold text-charcoal mb-2" data-id="element-188">
                      Thank You!
                    </h4>
                    <p className="text-charcoal/70 text-base font-medium" data-id="element-189">
                      We'll be in touch soon. Your healing journey matters to
                      us.
                    </p>
                  </div>}
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}